import useCurrency from "../../../../hook/useCurrency";

const BundleDiscountRow = ({ bundle, props, onSessionClick, isActiveDirectDeliveryCoupons }) => {
  const { display } = useCurrency();

  const formatCurrency = (amount) => {
    return display(amount, props.currencyCode);
  };

  return (
    <div class="relative bundle-discount-wrapper-mini mb-1" bis_skin_checked="1" onClick={() => onSessionClick(bundle)}>
      <div class="flex justify-content-start align-items-center gap-2" bis_skin_checked="1">
        <div class="flex flex-column gap-spacing-2 w-5rem bundle-discount-price-container justify-content-center" bis_skin_checked="1">
          <div class="keduall-typography heading-h6-medium-500 keduall-price keduall-original-price overflow-hidden	text-overflow-ellipsis" bis_skin_checked="1">{ bundle.discountPercentage > 0 && formatCurrency(props.defaultPrice * bundle.numberTicket)}</div>
          <div class="keduall-typography text-14-normal-400 text-secondary-txt" bis_skin_checked="1">{bundle.numberTicket} {props.ticketUnitLabel}</div>
        </div>
        <div class="keduall-typography heading-h5-semibold-600 overflow-hidden text-overflow-ellipsis keduall-price keduall-final-price" bis_skin_checked="1">
          {formatCurrency(
            props.defaultPrice *
            bundle.numberTicket *
            (1 - bundle.discountPercentage / 100)
          )}
        </div>
        { bundle.discountPercentage > 0 && <div class="w-4rem text-center" bis_skin_checked="1"><span class="keduall-tag upper-intermediate-tag keduall-typography text-14-medium-500 p-tag p-component keduall-price keduall-discount-percentage" data-pc-name="tag" data-pc-section="root"><span class="p-tag-value" data-pc-section="value">-{bundle.discountPercentage}%</span><span></span></span></div>}
        {isActiveDirectDeliveryCoupons &&  bundle.numberTicket === 1 && <div className="absolute collision-wrapper">
          <img src={props.couponIcon} alt="" className="coupon-label"/>
        </div> }
      </div> 
      
    </div>
    // <div className="grid">
    //   <div className="col-6">
    //     <div className="bundle-discount-original-price line-through keduall-typography heading-h6-medium-500 text-dark-txt">
    //       {formatCurrency(props.defaultPrice * bundle.numberTicket)}
    //     </div>
    //     <span className="keduall-typography text-14-medium-500 text-dark-txt">
    //       {bundle.numberTicket} {props.ticketUnitLabel},
    //     </span>
    //   </div>
    //   <div className="col-6">
    //     <div className="flex flex-row flex-nowrap justify-content-between align-items-center">
    //       <span className="keduall-typography heading-h5-semibold-600 text-default-txt">
    //         {formatCurrency(
    //           props.defaultPrice *
    //           bundle.numberTicket *
    //           (1 - bundle.discountPercentage / 100)
    //         )}
    //       </span>
    //       <span className="keduall-typography text-14-medium-500 text-error-txt align-self-start">
    //         -{bundle.discountPercentage}%
    //       </span>
    //     </div>
    //   </div>
    //   <div className="discount-badge-container"></div>
    // </div>
  );
};

const BundleDiscountTable = ({ bundles, props, onSessionClick, isActiveDirectDeliveryCoupons }) => {
  if (!bundles || bundles.length === 0) {
    return null;
  }

  return (
    <div className="keduall-bundle-discount-table mt-2">
      {bundles.map((bundle) => (
        <BundleDiscountRow key={bundle.id} bundle={bundle} props={props} onSessionClick={onSessionClick} isActiveDirectDeliveryCoupons={isActiveDirectDeliveryCoupons} />
      ))}
      
    </div>
  );
};

export default BundleDiscountTable;
